const updateDashboardStats = (state, payload) => {
  state.dashboardStats = payload.data
}

export default {
  updateDashboardStats
}



// WEBPACK FOOTER //
// ./src/store/modules/superAdminDashboard/mutations.js